export default {

    data: function () {
        return {
        }
    },

    computed: {
    },

    methods: {

        dividedMethodG(num1, num2){        
            
            console.log('num1=', num1, ' num2=', num2);

            if(num2 > 0)
            {
            let num1v = parseFloat(num1)
            let num2v = parseFloat(num2)

            let num1_v = (num1v > 0) ? num1v : 0;
            let num2_v = (!isNaN(num2v) && num2v > 0) ? num2v : 0;

            let div = num1_v/num2_v;
            let result = (div > 0) ? div : 0

            return result.toFixed(3);
            }
            else
            {
                return 0;
            }
        },

        multiplyMethodG(num1, num2){

            if(num1>0 && num2>0)
            {
                let num1v = parseFloat(num1)
                let num2v = parseFloat(num2)

                let num1_v = (num1v > 0) ? num1v : 0;
                let num2_v = (!isNaN(num2v) && num2v > 0) ? num2v : 0;

                let div = num1_v*num2_v;
                let result = (div > 0) ? div : 0

                return result.toFixed(3);
            }
            else{
                return 0;
            }
        },

        roundMethodG(num)
        {
            let numV = parseFloat(num);
            let result = (numV>0) ? numV : 0;
            return Math.round(result);
        },

        reset(){
          this.$refs.form.reset();
          this.formSchema.id = 0;
        }, 
    },

  filters: {
    currency(amount) {
      const amt = Number(amount);
      //console.log('amount========', amt);
      var a = amt && amt.toLocaleString(undefined, {maximumFractionDigits:3}) || '0'
      return a
    },

    numberWithCommas(amount) {
        const amt = amount;
        var a = amt && amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '0'
        return a;
    }

  },
}


// WEBPACK FOOTER //
// ./src/mixins/globalMethods.js